import { component } from "picoapp";
import { type Context } from "../../../../state";

export const videoCarouselModal = component<Context>((node, context) => {
  const target = node.dataset.tbspTarget;
  const openModal = () => {
    context.emit("tbsp:button-clicked", { action: "toggle-modal", target });
  };

  node.addEventListener("click", openModal);
  return () => {
    node.removeEventListener("click", openModal);
  };
});
